// Multiplication table data + helpers (client-side only)

export const TABLES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

// Per-table color themes (aligned with design_guidelines.json)
export const TABLE_THEMES = {
  1: { bg: '#38BDF8', border: '#0284C7', text: '#ffffff', name: 'Céu' },
  2: { bg: '#34D399', border: '#059669', text: '#053b2c', name: 'Folha' },
  3: { bg: '#FBBF24', border: '#D97706', text: '#422006', name: 'Sol' },
  4: { bg: '#FB923C', border: '#EA580C', text: '#ffffff', name: 'Laranja' },
  5: { bg: '#F472B6', border: '#DB2777', text: '#ffffff', name: 'Rosa' },
  6: { bg: '#C084FC', border: '#7C3AED', text: '#ffffff', name: 'Uva' },
  7: { bg: '#818CF8', border: '#4F46E5', text: '#ffffff', name: 'Anil' },
  8: { bg: '#22D3EE', border: '#0891B2', text: '#083344', name: 'Turquesa' },
  9: { bg: '#A3E635', border: '#65A30D', text: '#1a2e05', name: 'Limão' },
  10: { bg: '#FB7185', border: '#E11D48', text: '#ffffff', name: 'Coral' },
};

export const OPTION_COLORS = [
  { bg: '#FBBF24', border: '#D97706', text: '#422006' },
  { bg: '#34D399', border: '#059669', text: '#053b2c' },
  { bg: '#60A5FA', border: '#2563EB', text: '#ffffff' },
];

export function buildTable(n) {
  return Array.from({ length: 10 }, (_, i) => ({
    a: n,
    b: i + 1,
    result: n * (i + 1),
  }));
}

export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// Generate 3 answer options: correct + 2 plausible distractors, shuffled
export function makeOptions(question) {
  const { a, b, result } = question;
  const pool = new Set();
  // near multiples of the table
  [b - 1, b + 1, b + 2, b - 2].forEach((k) => {
    if (k >= 1 && k <= 12) pool.add(a * k);
  });
  // small offsets
  [result + a, result - a, result + 1, result - 1, result + 2].forEach((v) => {
    if (v > 0) pool.add(v);
  });
  pool.delete(result);
  const distractors = shuffle([...pool]).slice(0, 2);
  // safety fill
  let fill = result + 1;
  while (distractors.length < 2) {
    if (fill !== result && !distractors.includes(fill)) distractors.push(fill);
    fill += 1;
  }
  return shuffle([result, ...distractors]);
}

// Portuguese speech phrases
export function sayEquation(a, b, result) {
  return `${a} vezes ${b} é igual a ${result}`;
}

export function sayQuestion(a, b) {
  return `Quanto é ${a} vezes ${b}?`;
}

const PRAISE = [
  (n) => `Parabéns${n ? ', ' + n : ''}! Você acertou!`,
  (n) => `Muito bem${n ? ', ' + n : ''}! Isso mesmo!`,
  (n) => `Uhu${n ? ', ' + n : ''}! Resposta certinha!`,
  (n) => `Você é demais${n ? ', ' + n : ''}!`,
];

const ENCOURAGE = [
  () => `Ooops! Algo saiu errado. Vamos tentar novamente!`,
  () => `Quase! Tente de novo, você consegue!`,
  () => `Sem problema! Vamos tentar mais uma vez!`,
];

export function randomPraise(name) {
  return PRAISE[Math.floor(Math.random() * PRAISE.length)](name);
}

export function randomEncourage() {
  return ENCOURAGE[Math.floor(Math.random() * ENCOURAGE.length)]();
}
